import { createFileRoute } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { styled } from 'styled-components';

export const Route = createFileRoute('/_app/suspended')({
  component: SuspendedPage,
  beforeLoad: () => {
    return {
      pageBackground: 'white',
    };
  },
});

/**
 * The Account Suspended notice.
 *
 * Under `_app` so the full shell renders: the user dropdown is how a suspended
 * alias holder switches to another account, and it holds logout. `useAuthCheck`
 * sends users here; this page makes no API call and gates nothing.
 */
function SuspendedPage() {
  const { t } = useTranslation();
  return (
    <Notice data-testid="suspension-notice">
      <Title>{t('notifications.account-suspended')}</Title>
      <Body>{t('notifications.your-account-has-been')}</Body>
    </Notice>
  );
}

const Notice = styled.div`
  margin: 0 auto;
  max-width: 720px;
  padding: 60px 20px 120px;
`;

const Title = styled.h1`
  color: var(--grey-900);
  font-family: var(--raleway);
  font-size: 32px;
  font-weight: 700;
  margin-bottom: 24px;
`;

const Body = styled.p`
  color: var(--grey-900);
  font-family: var(--open-sans);
  font-size: 15px;
  line-height: 1.6;
`;
